import script from "./HistoryTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryTasks.vue?vue&type=script&setup=true&lang=js"

import "./HistoryTasks.vue?vue&type=style&index=0&id=14a7540c&lang=scss&scoped=true"

import exportComponent from "C:\\AQRepo\\customermanagedinspection_fe-brands-kra-norden\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14a7540c"]])

export default __exports__